import {
  CollectionIcon,
  DeliverIcon,
  LocationIcon,
  TotalOrdersIcon,
} from "../../assets/icons";

export const API_URL =
  process.env.REACT_APP_API_URL || "https://lynx-v1-apis.azurewebsites.net/api";

export const CashierActionList = [
  {
    label: "Total Services",
    icon: <TotalOrdersIcon size="45px" />,
  },
  {
    label: "Total Locations",
    icon: <LocationIcon size="45px" />,
  },
  {
    label: "Deliveries",
    icon: <DeliverIcon size="45px" />,
  },
  {
    label: "Collections",
    icon: <CollectionIcon size="45px" />,
  },
];

export const PAYLOAD_STEPS = ["cash", "coins", "valuables", "documents"];

export const STEPS = ["Cash", "Coins", "Valuables", "Documents"];

export const MIN_DATE = `${new Date().getFullYear()}-${new Date().getMonth() < 10 ? 0 : ""}${new Date().getMonth() + 1}-${
  new Date().getDate() < 10 ? 0 : ""
}${new Date().getDate()}`;
